import {
  IconApplePaySquare,
  IconDefaultCard,
  IconGooglePaySquare,
  IconMasterCardSquare,
  IconPayPalSquare,
  IconVisaSquare,
} from '@/assets/static/icons';
import { PaymentSourceTypeEnum } from '@/types/generated/graphql';

export function getCardIcon(brand?: string | null, type?: PaymentSourceTypeEnum | null) {
  if (type === PaymentSourceTypeEnum.apple_pay) {
    return (
      <span className="size-10">
        <IconApplePaySquare />
      </span>
    );
  }
  if (type === PaymentSourceTypeEnum.google_pay) {
    return (
      <span className="size-10">
        <IconGooglePaySquare />
      </span>
    );
  }

  switch (brand) {
    case 'visa':
      return (
        <span className="size-10">
          <IconVisaSquare />
        </span>
      );
    case 'mastercard':
      return (
        <span className="size-10">
          <IconMasterCardSquare />
        </span>
      );
    case 'paypal':
      return <IconPayPalSquare />;
    default:
      return (
        <span className="size-10">
          <IconDefaultCard className="size-10 rounded-lg" />
        </span>
      );
  }
}
